import type { ReactElement } from 'react'

import './styles.scss'

const InfiniteProgressBar = (): ReactElement | null => {
  return (
    <div className="progress-bar-component">
      <div className="progress-bar-component__progress" />
    </div>
  )
}

export default InfiniteProgressBar
